import './App.css';
import Navbar from './component/Navbar';
import HeroSection from './component/HeroSection';
import AboutUs from './component/AboutUs';
import Footer from './component/Footer';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import WebsitesDevelopment from './component/WebsitesDevelopment';
import AppDevelopment from './component/AppDevelopment';
import DigitalMarketing from './component/DigitalMarketing';
import Blog from './component/Blog';
import ContactUs from './component/ContactUs';
import EcommerceWebsite from './component/EcommerceWebsite';
import VideoProduction from './component/VideoProduction';
import Graphicdesign from './component/Graphicdesign';
import SMMar from './component/SMMar';
import Whatsappapi from './component/Whatsappapi';
import CustomSoftware from './component/CustomSoftware';
import PrivacyPolicy from './component/PrivacyPolicy';
import TermsOfService from './component/TermsOfService';
import Loader from './component/Loader';
import FloatingWidgets from './component/FloatingWidgets';
import Staticwebsite from './component/staticwebsite';
import MetaAds from './component/Metaads';
import Googleads from './component/Googleads';
import Hotstarads from './component/Hotstarads';
import React, { useState, useEffect } from 'react';

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Show loader for 2.5 seconds on initial load
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500);
    
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-[#061225] flex flex-col">
        {/* Navbar is placed outside Routes so it always shows on all pages */}
        <Navbar />

        {/* Page Content */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HeroSection />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/services/websites" element={<WebsitesDevelopment />} />
            <Route path="/services/staticwebsites" element={<Staticwebsite />} />
            <Route path="/services/apps" element={<AppDevelopment />} />
            <Route path="/services/marketing" element={<DigitalMarketing />} />
            <Route path="/services/ecommerce" element={<EcommerceWebsite />} />
            <Route path="/services/software" element={<CustomSoftware />} />
            <Route path="/services/video-production" element={<VideoProduction />} />
            <Route path="/services/graphics-designing" element={<Graphicdesign />} />
            <Route path="/services/social-media-marketing" element={<SMMar />} />
            <Route path="/services/whatsapp-api" element={<Whatsappapi />} />
            <Route path="/blogs" element={<Blog />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/services/Metaads" element={<MetaAds />} />
            <Route path="/services/Googleads" element={<Googleads />} />
            <Route path="/services/Hotstarads" element={<Hotstarads />} />
          </Routes>
        </main>

        <FloatingWidgets />
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
